<template>
  <v-container
    fluid
    mt-6
    pa-0
    style="width: 540px"
  >
    <v-card
      class="
        pa-6
        mt-6
      "
    >
      <div
        class="
          d-flex
          justify-center
        "
      >
        <v-img
          src="../assets/logo.png"
          alt="Trouver son cadeau logo"
          max-width="100px"
        />
      </div>

      <h2
        class="
          headline
          text-center
          mb-6
        "
      >Sign in</h2>

      <v-form
        @submit.prevent="submit()"
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="credentials.email"
          label="Email"
          :rules="rules.email"
        ></v-text-field>

        <v-text-field
          v-model="credentials.password"
          type="password"
          label="Password"
          :rules="rules.password"
        ></v-text-field>

        <v-alert
          type="error"
          v-if="error"
        >{{ error }}</v-alert>

        <v-row
          justify="end"
        >
          <!-- <v-btn
            text
            class="mr-3"
            :to="{ name: 'register' }"
          >Create an account</v-btn> -->

          <v-btn
            :disabled="!valid"
            color="primary"
            type="submit"
            depressed
          >Sign in</v-btn>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      error: null,
      credentials: {},
      rules: {
        email: [v => !!v || 'Email is required'],
        password: [v => !!v || 'Password is required']
      }
    }
  },
  methods: {
    async submit() {
      this.error = null
      if (!this.$refs.form.validate()) return
      try {
        await this.$auth.login(this.credentials)
        this.$router.push({ name: 'home' })
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.error = 'Wrong email or password'
        } else this.error = 'An error occured'
      }
    }
  }
}
</script>
